import React, { Component, createRef } from 'react'
import { connect } from 'react-redux'
import { List, Map } from 'immutable';
import { TransitionGroup, CSSTransition } from "react-transition-group";

import { QuestionItem, Start, Ready, Rearrenge, ResultModal, Summary, Report, ListResponse } from '../components/thinkingtalents'
import { Row, Col, Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { ModalSubmitAssessment } from '../components/common/assessments-modals';

import { questionsListActions, getCurrentQuestionsList } from '../../core/questions-list'
import { assessmentsListActions, getCurrentAssessmentsList, getAssessmentForCurrentAssessmentsList } from '../../core/assessments-list'
import { trackingActions } from '../../core/tracking';

import { DEFAULT_SESSION_ID, SYSTEM_ID_NEXT_ASSESSMENT } from '../../core/constants'

import LoadingIndicator from '../components/loading-indicator'
import { userActions } from '../../core/users';

import ReactGA from 'react-ga';
import { Scrollbar } from 'react-scrollbars-custom';
import { getSystemById } from '../../core/system';

class ThinkingTalentsPage extends Component {

  constructor(props) {
    super(props);
    this.scrollbarRef = React.createRef();

    this.state = {
      current_step: 0,
      current_section: 'start',
      result_valid: false,
      next_step: false,
      total_questions: 3,
      question_index: 0,
      direction: 'right',
      animationClass: {
        appearActive: 'animate__animated animate__slideInRight',
        enter: 'animate__animated',
        enterActive: 'animate__animated animate__slideInRight',
        exit: 'animate__animated',
        exitActive: 'animate__animated animate__slideOutLeft',
      },
      response_list: new Map(),
      validations: {
        valid: true,
        group_1: {
          name: 'always',
          valid: true,
          message: ""
        },
        group_2: {
          name: 'sometimes',
          valid: true,
          message: ""
        },
        group_3: {
          name: 'never',
          valid: true,
          message: ""
        },
      },
      response_items_by_groups: {
        group_1: new List(),
        group_2: new List(),
        group_3: new List(),
      },
      is_run_validate: false,
      rearrange_first_time: false,
      prevState: false,
      open_modal_submit: false,
      modal_list: false,

      questionsRef: createRef(),
      sectionsRef: createRef()
    }

    this.hanndleQuestionResponse = this.hanndleQuestionResponse.bind(this);
    this.hanndleNextQuestion = this.hanndleNextQuestion.bind(this);
    this.hanndlePrevQuestion = this.hanndlePrevQuestion.bind(this);
    this.hanndleValidations = this.hanndleValidations.bind(this);
    this.hanndleRearrengeResponse = this.hanndleRearrengeResponse.bind(this);
    this.getTalentsItems = this.getTalentsItems.bind(this);
    this.save = this.save.bind(this);
    this.hanndleEditQuestionResponse = this.hanndleEditQuestionResponse.bind(this);
    this.changeResponse = this.changeResponse.bind(this);
    this.getNextUnansweredQuestion = this.getNextUnansweredQuestion.bind(this);
    this.selectQuestion = this.selectQuestion.bind(this);
  }

  // Función para alternar la visibilidad del modal
  toggleModal = () => {
    this.setState(prevState => ({
      modal_list: !prevState.modal_list
    }));
  };

  componentDidMount = () => {
    if(this.props.is_current_user) {
        this.props.loadAssessments()
    }
    this.props.loadQuestions()

    if(this.props.section) {
        this.hanndleNextQuestion(this.props.section)
    }
  }

  selectQuestion(questionId) {
    let step = this.props.questions_list.items.findIndex(question => question.id == questionId);
    if (questionId === 'lastUnaswered') {
      step = this.getNextUnansweredQuestion().index;
    }

    this.setState({
      current_step: step,
      next_step: true,
      scroll_position: this.scrollbarRef.current.scrollValues.scrollTop
    });
  }

  hanndleEditQuestionResponse(id, value) {
    this.changeResponse(id, value);
    this.goToNextQuestionUnaswered();
  }

  changeResponse(id, value) {
    const { response_list, response_items_by_groups } = this.state;
    const { questions_list } = this.props;

    const item = { item_id: id, value };
    const old_item = response_list.get(id);
    const new_response_list = response_list.set(id, item);

    let new_response_items_by_groups = {...response_items_by_groups};
    // Remove from previous group
    const oldGroupKey = 'group_' + old_item.value;
    new_response_items_by_groups = {
      ...new_response_items_by_groups,
      [oldGroupKey]: new_response_items_by_groups[oldGroupKey].filter(i => i.item_id !== id)
    };

    // Add to new group
    const newGroupKey = 'group_' + value;
    new_response_items_by_groups = {
        ...new_response_items_by_groups,
        [newGroupKey]: (new_response_items_by_groups[newGroupKey] || []).concat(item)
    };

    let newList = null;
    let valuesNames = { 1: 'always', 2: 'sometimes', 3: 'never' };
    if (new_response_list.size > 0) {
      newList = Array.from(new_response_list.entries());
      newList.sort(([indexA], [indexB]) => indexA - indexB);
      newList.forEach(([index, item]) => {
        let question = questions_list.items.find(question => question.id === item.item_id);
        item.name = question.name;
        item.icon_invert = question.icon_invert;
        item.value_name = valuesNames[item.value];
        item.description = question.description;
      });
    }

    this.setState({
      response_list_data: newList,
      response_list: new_response_list,
      response_items_by_groups: new_response_items_by_groups,
    });
  }

  getNextUnansweredQuestion () {
    const { questions_list } = this.props
    const { response_list_data } = this.state

    const lastAnsweredQuestionId = response_list_data?.length ? response_list_data[response_list_data.length - 1][1].item_id : [];
    const lastAnsweredQuestionIndex = questions_list.items.findIndex(question => question.id === lastAnsweredQuestionId);
    const nextQuestionIndex = lastAnsweredQuestionIndex + 1;
    const nextUnansweredQuestion = questions_list.items.get(nextQuestionIndex);

    return { question: nextUnansweredQuestion, index: nextQuestionIndex };
  }

  goToNextQuestionUnaswered() {
    const nextUnansweredQuestion = this.getNextUnansweredQuestion();

    this.setState({
      current_step: nextUnansweredQuestion.index,
      next_step: true
    });
  }

  hanndleQuestionResponse(id, value) {
    const { response_list, current_step, response_items_by_groups } = this.state
    const { questions_list } = this.props

    const item = { item_id: id, value }

    const new_response_list = response_list.set(id, item)

    const new_response_items_by_groups = Object.assign({}, response_items_by_groups, {
      ['group_' + item.value]: response_items_by_groups['group_' + item.value].push(item),
    })
  
    let newList = null
    let valuesNames = { 1 : 'always', 2 : 'sometimes', 3 : 'never' }
    if (new_response_list.size > 0 ){
      newList = Array.from(new_response_list.entries())
      newList.sort(([indexA], [indexB]) => indexA - indexB);
      newList.forEach(([index, item]) => {
        let question = questions_list.items.find(question => question.id === item.item_id);
        item.name = question.name;
        item.icon_invert = question.icon_invert;
        item.value_name = valuesNames[item.value];
        item.description = question.description;
      });
    }

    this.setState({ response_list_data: newList, response_list: new_response_list, response_items_by_groups: new_response_items_by_groups });

    if (current_step !== questions_list.items.size)
      this.hanndleNextQuestion('questions');
    else {
        ReactGA.event({
            category: 'Thinking Talent',
            action: 'Creation completed'
        })
        this.props.saveTrackingEvent({category: 'Thinking Talent', action: 'Creation completed'})
      this.hanndleNextQuestion('result_1');
    }

  }

  hanndleRearrengeResponse(id, value) {
    const { response_list, validations, response_items_by_groups } = this.state;

    const old_item = response_list.get(id)
    const item = { item_id: id, value }
    const new_response_list = response_list.set(id, item)

    const new_validations = Object.assign({}, validations, {
      is_run_validate: false
    })

    const new_response_items_by_groups = Object.assign({}, response_items_by_groups, {
      ['group_' + item.value]: new List([item]).merge(response_items_by_groups['group_' + item.value]),
      ['group_' + old_item.value]: response_items_by_groups['group_' + old_item.value].filter(i => i.item_id !== old_item.item_id)
    })

    this.setState({ response_list: new_response_list, validations: new_validations, response_items_by_groups: new_response_items_by_groups });

  }

  save() {
    const { rearrange_first_time, response_list } = this.state;
    const { saveAssessment, assessment } = this.props;

    if(!rearrange_first_time) {
      ReactGA.event({
        category: 'Thinking Talent',
        action: 'Rearrange completed',
      })
    }

    this.props.saveTrackingEvent({category: 'Thinking Talent', action: 'Rearrange completed', first_time: rearrange_first_time})
    saveAssessment(assessment.id, response_list);
    // this.setState({ current_section: 'report' });
  }

  hanndleNextQuestion(section = 'questions', valid) {
    const { rearrange_first_time } = this.state
    const { currentUser, user, is_current_user } = this.props;

        if (section === 'result' && valid) {
          // if(rearrange_first_time && user?.assessments_block_days) {
          //   this.setState({ open_modal_submit: true })
          //   return;
          // }
        
          this.setState({ open_modal_submit: true })
          return;
        }

        if (section === "report" && is_current_user) {
          currentUser();
        }
        
        const animationClass = {
        appearActive: 'animate__animated animate__slideInRight position-absolute',
        enter: 'animate__animated',
        enterActive: 'animate__animated animate__slideInRight position-absolute',
        exit: 'animate__animated',
        exitActive: 'animate__animated animate__slideOutLeft position-absolute',
        }

        let result_valid = false;

        if (valid) {
        result_valid = valid
        }

        this.setState({ direction: 'right', next_step: true, current_section: section, animationClass, result_valid });
  }

  hanndlePrevQuestion() {
    const animationClass = {
      appearActive: 'animate__animated animate__slideInLeft position-absolute',
      enter: 'animate__animated',
      enterActive: 'animate__animated animate__slideInLeft position-absolute',
      exit: 'animate__animated',
      exitActive: 'animate__animated animate__slideOutRight position-absolute',
    }
    this.setState({ direction: 'left', next_step: true, animationClass });
  }

  getTalentsItems() {
    const { user } = this.props
    if(user && user?.talents) {
        let items = []
        user.talents.map((talent) => {
            return talent?.items?.map((item) => {
                items.push({...item, item_id: item.id})
            })
        })
        return items
    }
    return []
  }

  componentDidUpdate(oldProps, oldState) {
    const { direction, next_step, current_step, current_section, validations, response_list, rearrange_first_time } = this.state;
    const { questions_list, assessment, assessment_items } = this.props;
  
    if (current_section === 'questions' && next_step) { // added from componentWillUpdate
      if (direction === 'right') {
        this.setState({ current_step: current_step + 1, next_step: false });
      } else if (direction === 'left') {
        this.setState({ current_step: current_step - 1, next_step: false });
      }
    }

    if (oldState.current_section === 'report' && current_section === 'result_1') {
      this.setState({ prevState: true })
    }

    if(current_section === "questions" && !rearrange_first_time) {
        this.setState({ rearrange_first_time: true })
    }

    if ((current_section === 'result' || current_section === 'result_1' || current_section === 'rearrenge') && !validations.is_run_validate && questions_list.items.size === response_list.size) {
      this.hanndleValidations();
    }

    if ((current_section === "questions" || current_section === "start") && assessment.id && assessment.id !== DEFAULT_SESSION_ID) {
      const new_response_list = assessment_items.filter(item => item.assessment_id === assessment.id)

      let grupo_1 = []
      let grupo_2 = []
      let grupo_3 = []

      new_response_list.forEach(item => {
        switch (item.value) {
            case "1":
                grupo_1.push(item);
                break;
            case "2":
                grupo_2.push(item);
                break;
            case "3":
                grupo_3.push(item);
                break;
            default:
                break;
        }
      });

      const response_items_by_groups = {
        group_1: new List(grupo_1),
        group_2: new List(grupo_2),
        group_3: new List(grupo_3)
      }

      let next_section = 'rearrenge'

      if (current_section === "start") {
        next_section = 'report'
      }

      this.setState({ current_section: next_section, response_list: new_response_list, response_items_by_groups })

    }

  }
  hanndleValidations() {
    const { response_items_by_groups } = this.state
    const { questions_list } = this.props

    let validations = {
      group_1: {
        name: 'always',
        valid: true,
        message: ""
      },
      group_2: {
        name: 'sometimes',
        valid: true,
        message: ""
      },
      group_3: {
        name: 'never',
        valid: true,
        message: ""
      },
      valid: true,
      is_run_validate: true
    }

    /* GRUPO 1 */
    let rules = questions_list.range.get("1");

    if (rules) {
      if (response_items_by_groups.group_1.size < rules.min) {
        validations = Object.assign({}, validations, {
          group_1: {
            name: 'always',
            valid: false,
            message: `Minimum ${rules.min}`,
            error: 'min'
          },
          valid: false
        })
      }

      if (response_items_by_groups.group_1.size > rules.max) {
        validations = Object.assign({}, validations, {
          group_1: {
            name: 'always',
            valid: false,
            message: `Maximum ${rules.max}`,
            error: 'max'
          },
          valid: false
        })
      }
    }

    /* GRUPO 2 */
    rules = questions_list.range.get("2");
    if (rules) {
      if (response_items_by_groups.group_2.size < rules.min) {
        validations = Object.assign({}, validations, {
          group_2: {
            name: 'sometimes',
            valid: false,
            message: `Minimum ${rules.min}`,
            error: 'min'
          },
          valid: false
        })
      }

      if (response_items_by_groups.group_2.size > rules.max) {
        validations = Object.assign({}, validations, {
          group_2: {
            name: 'sometimes',
            valid: false,
            message: `Maximum ${rules.max}`,
            error: 'max'
          },
          valid: false
        })
      }
    }

    /* GRUPO 3 */
    rules = questions_list.range.get("3");
    if (rules) {
      if (response_items_by_groups.group_3.size < rules.min) {

        validations = Object.assign({}, validations, {
          group_3: {
            name: 'never',
            valid: false,
            message: `Minimum ${rules.min}`,
            error: 'min'
          },
          valid: false
        })
      }


      if (response_items_by_groups.group_3.size > rules.max) {
        validations = Object.assign({}, validations, {
          group_3: {
            name: 'never',
            valid: false,
            message: `Maximum ${rules.max}`,
            error: 'max'
          },
          valid: false
        })
      }
    }

    this.setState({ validations, response_items_by_groups })

  }
  
  render() {
    const { response_list_data, response_list, current_step, animationClass, current_section, response_items_by_groups, validations, prevState, rearrange_first_time, open_modal_submit, scroll_position, questionsRef, sectionsRef } = this.state;
    const { displayLoadingIndicator, questions_list, user, is_current_user, view_mode, animation } = this.props;

    if (displayLoadingIndicator || (user.checked && !user.id))
      return <LoadingIndicator className="text-center" style={{ "marginTop": "15px", "display": "block" }} />;

    let question = null;
    let response_value = null;

    if (current_step) {
      if (!questions_list.items.size)
        return null;
      question = questions_list.items.get(current_step - 1)
      response_value = response_list.get(question.id);
    }

    const nextUnansweredQuestion = this.getNextUnansweredQuestion();
    const talentsNumber = response_list_data?.length + 1 || 1;

    return (
      <>
      <div className="container-fluid minh-100">
        <ModalSubmitAssessment 
          isOpen={open_modal_submit} 
          close={() => this.setState({ open_modal_submit: false })} 
          onAccept={() => { 
            this.save()
            this.setState({ open_modal_submit: false })
          }} 
          onCancel={() => this.setState({ open_modal_submit: false })} 
          blockDays={user?.assessments_block_days}
          showMessage={user?.assessments_block_days && rearrange_first_time}
        />
        {/* Ni bien termine de guardar, quizas en el mismo sagas llamamos a la action que carga el siguiente paso */}
        
        <div className="view overflow-hidden ttalent-content">
        <TransitionGroup component={null} >
          <CSSTransition nodeRef={sectionsRef} classNames={animation && animationClass} timeout={{ enter: 1000, exit: 1000 }} key={`${current_section}${current_step === 0 ? '' : '_initialized'}`} appear>
            <div ref={sectionsRef}>
              {current_section === 'start' && <Start hanndleNextQuestion={this.hanndleNextQuestion} user={user} />}

              {(current_section === "questions" && current_step > 0) && 
              <div className='content-questions w-100'>
                <Row key={current_step} className="flex-row-reverse">
                  <Col>
                    <div className="rounded border-md question-steps">
                      <div className='d-flex justify-content-between align-items-center mx-lg-3 py-3'>
                        <p className='h5 font-weight-semibold mb-0'>Talents</p>
                        <div className="paginador ml-auto"><p className='h5 font-weight-semibold mb-0'>{talentsNumber}/{questions_list.items.size}</p></div>
                        <Button color="outline-primary" size='sm' className='ml-2 p-1 d-lg-none' onClick={this.toggleModal}>
                          <svg width="14" height="14" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 14 14" fill="currentColor">
                            <path d="M12.5,7c0,0.2-0.1,0.3-0.2,0.5c-0.1,0.1-0.3,0.2-0.5,0.2H7c-0.2,0-0.3-0.1-0.5-0.2C6.4,7.3,6.3,7.2,6.3,7
                              c0-0.2,0.1-0.3,0.2-0.5C6.7,6.4,6.8,6.3,7,6.3h4.8c0.2,0,0.3,0.1,0.5,0.2C12.4,6.7,12.5,6.8,12.5,7z M7,4.2h4.8
                              c0.2,0,0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5c0-0.2-0.1-0.3-0.2-0.5c-0.1-0.1-0.3-0.2-0.5-0.2H7C6.8,2.8,6.7,2.9,6.5,3
                              C6.4,3.2,6.3,3.3,6.3,3.5c0,0.2,0.1,0.3,0.2,0.5C6.7,4.1,6.8,4.2,7,4.2z M11.8,9.8H7c-0.2,0-0.3,0.1-0.5,0.2
                              c-0.1,0.1-0.2,0.3-0.2,0.5c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.2h4.8c0.2,0,0.3-0.1,0.5-0.2c0.1-0.1,0.2-0.3,0.2-0.5
                              c0-0.2-0.1-0.3-0.2-0.5C12.2,9.9,12,9.8,11.8,9.8z M4.3,2.2L3.1,3.4L2.7,3C2.5,2.9,2.4,2.8,2.2,2.8C2,2.8,1.8,2.9,1.7,3
                              C1.6,3.2,1.5,3.3,1.5,3.5c0,0.2,0.1,0.3,0.2,0.5l0.9,0.9C2.7,4.9,2.7,4.9,2.8,5C2.9,5,3,5,3.1,5C3.2,5,3.2,5,3.3,5
                              c0.1,0,0.2-0.1,0.2-0.1l1.8-1.7C5.4,3,5.5,2.8,5.5,2.6c0-0.2-0.1-0.3-0.2-0.5C5.2,2,5,2,4.8,2C4.6,2,4.5,2,4.3,2.2L4.3,2.2z
                              M4.3,5.7L3.1,6.9L2.7,6.5C2.5,6.4,2.4,6.3,2.2,6.3C2,6.3,1.8,6.4,1.7,6.5C1.6,6.7,1.5,6.8,1.5,7c0,0.2,0.1,0.3,0.2,0.5l0.9,0.9
                              c0.1,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0.1,0.3,0.1c0.1,0,0.2,0,0.3-0.1c0.1,0,0.2-0.1,0.2-0.1l1.8-1.8c0.1-0.1,0.2-0.3,0.2-0.5
                              c0-0.2-0.1-0.3-0.2-0.5C5.2,5.5,5,5.5,4.8,5.5C4.6,5.5,4.5,5.5,4.3,5.7L4.3,5.7z M4.3,9.2l-1.3,1.3L2.7,10C2.6,10,2.5,9.9,2.4,9.9
                              c-0.1,0-0.2-0.1-0.3-0.1c-0.1,0-0.2,0-0.3,0.1C1.9,9.9,1.8,10,1.7,10c-0.1,0.1-0.1,0.1-0.1,0.2c0,0.1-0.1,0.2-0.1,0.3s0,0.2,0.1,0.3
                              c0,0.1,0.1,0.2,0.1,0.2l0.9,0.9c0.1,0.1,0.1,0.1,0.2,0.1C2.9,12,3,12,3.1,12c0.1,0,0.2,0,0.3-0.1c0.1,0,0.2-0.1,0.2-0.1l1.8-1.8
                              C5.4,10,5.5,9.8,5.5,9.6S5.4,9.3,5.3,9.2C5.2,9,5,9,4.8,9C4.6,9,4.5,9,4.3,9.2L4.3,9.2z"/>
                          </svg>
                        </Button>
                      </div>
                      <div className='lista-question-steps mb-3 d-none d-lg-block'>
                        <Scrollbar style={{ width: '100%', height: '100%' }} thumbsize={60} ref={this.scrollbarRef}>
                          <ListResponse
                            list={response_list_data}
                            question={nextUnansweredQuestion.question}
                            selectQuestion={this.selectQuestion}
                            scrollbarRef={this.scrollbarRef}
                            scrollPosition={scroll_position}
                          />
                        </Scrollbar>
                      </div>
                    </div>
                  </Col>
                  <Col lg={{ size: 8 }} xs={12} className='overflow-hidden col-question'>
                    <TransitionGroup component={null} >
                      <CSSTransition nodeRef={questionsRef} classNames={animation && animationClass} timeout={{ enter: 1000, exit: 1000 }} key={current_step} appear={current_step > 1 ? true : false} >
                      <div ref={questionsRef} className='rounded border p-3 question-card'>
                        <div className="nav d-none">
                          <button className="btn btn-outline-secondary" onClick={this.hanndlePrevQuestion} disabled={current_step <= 1}>{" « Prev "}</button>&nbsp;&nbsp;
                          <button className="btn btn-outline-secondary" disabled={current_step === questions_list.items.size} onClick={() => this.hanndleNextQuestion('questions')}>{" Next » "}</button>
                        </div>
                        <QuestionItem data={question} hanndleResponse={ (response_list_data?.length > 0 && current_step-1 !== response_list_data.length) ? this.hanndleEditQuestionResponse : this.hanndleQuestionResponse} select_option={response_value} />
                      </div>
                      </CSSTransition>
                    </TransitionGroup>
                  </Col>
                </Row>
              </div>
              }
              
              {current_section === "ready" && <Ready key="ready" hanndleNextQuestion={this.hanndleNextQuestion} /> }

              {current_section === "rearrenge" && <Rearrenge key="rearrenge" items={response_items_by_groups} response_list={response_list} validations={validations} questions={questions_list.items} response_range={questions_list.range} hanndleResponse={this.hanndleRearrengeResponse} hanndleNextQuestion={this.hanndleNextQuestion} />}

              {(current_section === "result" || current_section === "result_1") &&  <ResultModal key="result" user={user} validations={validations} items={response_items_by_groups} section={current_section} response_range={questions_list.range} hanndleNextQuestion={this.hanndleNextQuestion} prevState={prevState} />}

              {current_section === "summary" && <Summary key="summary" items={response_items_by_groups.group_1} questions={questions_list.items} hanndleNextQuestion={this.hanndleNextQuestion} />}

              {current_section === "report" && <Report key="report" user={user} view_mode={view_mode} items={ is_current_user ? response_items_by_groups.group_1 : this.getTalentsItems() } quadrants={questions_list.quadrants} questions={questions_list.items} hanndleNextQuestion={this.hanndleNextQuestion} />}
            </div>
          </CSSTransition>
        </TransitionGroup>
        </div>
      </div>
      {displayLoadingIndicator && <LoadingIndicator/>}

      <Modal isOpen={this.state.modal_list} toggle={this.toggleModal} className='modal-list-response'>
        <ModalHeader tag="div" toggle={this.toggleModal} wrapTag="div" className='border-bottom-0' cssModule={{ 'modal-title' : 'modal-title w-100 pr-4'}}>
          <div className='d-flex justify-content-between align-items-center'>
            <p className='h5 font-weight-semibold mb-0'>Talents</p>
            <div className="paginador ml-auto"><p className='h5 font-weight-semibold mb-0'>{current_step}/{questions_list.items.size}</p></div>
          </div>
        </ModalHeader>
        <ModalBody className='p-0'>
          <div className='lista-question-steps mb-3'>
            <ListResponse 
              list={response_list_data} 
              question={nextUnansweredQuestion.question}
              selectQuestion={this.selectQuestion}
            />
          </div>
        </ModalBody>
      </Modal>

      </>
    );
  }
}
//export default ThinkingTalentsPage;
//=====================================
//  CONNECT
//-------------------------------------

const mapStateToProps = (state, props) => {
  const { questions, user } = state
  const currentAssessment = getCurrentAssessmentsList(state);
  const dataNextAssessment = getSystemById(state, SYSTEM_ID_NEXT_ASSESSMENT);

  return {
    user: props.user || user,
    is_current_user: props.user ? false : true,
    view_mode: props.user ? true : false,
    questions_list: questions,
    assessment: currentAssessment,
    assessment_items: getAssessmentForCurrentAssessmentsList(state),
    displayLoadingIndicator: questions.isPending || currentAssessment.isPending || dataNextAssessment?.isPending,
    animation: props.animation !== undefined ? props.animation : true
  };
};

const mapDispatchToProps = {

  loadQuestions: questionsListActions.loadQuestions,
  createAssessments: assessmentsListActions.createAssessments,
  saveAssessment: assessmentsListActions.saveAssessment,
  loadAssessments: assessmentsListActions.loadAssessments,
  currentUser: userActions.currentUser,
  saveTrackingEvent: trackingActions.saveTrackingEvent
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ThinkingTalentsPage);
